import React, {Component} from 'react';
import * as func from "../../../utils/functions";
import {
	getNumberFormat,
	getObjectLength,
	getSelectFormat,
	objectToQueryString,
	pushUrl
} from "../../../utils/functions";
import {BASE_PATH, AUTHORITY_FACET_NAME, STATUS_NAME} from "../../../wpconfig";
import SelectBox from "../../etc/SelectBox";

// import Facet from "../../../components/admin/sidebar/facet";
// import Search from "./facet/search";

class AuthorityFacet extends Component {
	constructor(props) {
		super(props);

		this.state = {
			url: 'wp-admin/admin.php?page=researchmind-authority&',
			action: 'admin/authority_list'
		}
	}

	facetReset = (event) => {
		var param = this.props.param;
		Object.keys(this.props.param).map((key, i) => {
			if (!param[key] || param[key].length <= 0)
				return;
			if (key === 'records_per_page' || key === 'order' || key === 'orderby') {
			} else if (key === 'date_type') {
				param[key] = 'input_date';
			} else if (key === 'current_page') {
				param[key] = 1;
			} else if (Array.isArray(param[key])) {
				param[key] = [];
			} else {
				param[key] = "";
			}
		});

		this.props.setData({param: param});

		func.getData(this.state.action, this.props.param).then((response) => {
			this.props.setData({
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			});
			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
		});
	}

	argsInputTextEvnet = (event) => {
		let param = this.props.param;
		param[event.target.name] = event.target.value;
		this.props.setData({param: param});

		if (event.key === "Enter") {
			this.search()
		}
	}

	facetChangeEvent = (event) => {
		if (event.target.type === "checkbox") {
			let param = this.props.param;
			if (event.target.checked) {
				if (param[event.target.name].indexOf(event.target.value) < 0) {
					param[event.target.name].push(event.target.value);
				}
			} else {
				if (param[event.target.name].indexOf(event.target.value) > -1) {
					param[event.target.name].splice(param[event.target.name].indexOf(event.target.value), 1);
				}
			}
			this.props.setData({param: param});

			func.getData(this.state.action, param).then((response) => {
				this.props.setData({
					records: response.records,
					facet: response.facet,
					totalRecords: response.pageInfo.totalResults,
					totalPage: response.pageInfo.totalPage,
				});

				const url = objectToQueryString(param);
				pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
			});
		} else if (event.target.type === "button") {
			let param = this.props.param;
			if (param[event.target.name].indexOf(event.target.value) < 0) {
				param[event.target.name].push(event.target.value);
			}
			this.props.setData({param: param});

			func.getData(this.state.action, param).then((response) => {
				this.props.setData({
					records: response.records,
					facet: response.facet,
					totalRecords: response.pageInfo.totalResults,
					totalPage: response.pageInfo.totalPage,
				});

				const url = objectToQueryString(param);
				pushUrl('검색', BASE_PATH + this.state.url + url, param);
			});
		} else {
			let param = this.props.param;
			param[event.target.name] = event.target.value;
			this.props.setData({param: param});
		}
	}
	//
	// facetReset = (event) => {
	// 	var param = this.props.param;
	// 	Object.keys(this.props.param).map((key, i) => {
	// 		if (!param[key] || param[key].length <= 0)
	// 			return;
	// 		if (key === 'records_per_page' || key === 'order' || key === 'orderby') {
	// 		} else if (key === 'current_page') {
	// 			param[key] = 1;
	// 		} else if (Array.isArray(param[key])) {
	// 			param[key] = [];
	// 		} else {
	// 			param[key] = "";
	// 		}
	// 	});
	//
	// 	const {dataActions} = this.props;
	// 	dataActions.setJournals({"param": param});
	// 	func.getData(this.state.action, this.props.param).then((response) => {
	// 		this.props.dataActions.setJournals(response);
	//
	// 		pushUrl('검색', BASE_PATH + 'journals/', null);
	// 	});
	// }

	search = (event) => {
		func.getData(this.state.action, this.props.param).then((response) => {
			this.props.setData({
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			});

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.props.param);
		});
	}

	render() {
		const param = this.props.param;

		return (
			<>
				<div className="d-flex justify-content-between align-items-center">
					<h6 className="con-title">패싯 검색</h6>
					<div className="d-flex">
						<button type="button" className="btn-search-ui ml-2" onClick={this.facetReset}>
							<span className="icon icon-size-24 icon-refresh-white"/>
						</button>
					</div>
				</div>
				{/*<div className="form-group mt-3">*/}
				{/*	<label htmlFor="within_ks" className="form-label"><strong>결과내 검색</strong></label>*/}
				{/*	<div className="input-group">*/}
				{/*		<input type="text" name="within_ks" id="within_ks" className="form-control" value=""*/}
				{/*		       onChange={this.onChange}/>*/}
				{/*		<button className="btn btn-sm btn-primary" type="button" id="search_within_ks">검색</button>*/}
				{/*	</div>*/}
				{/*</div>*/}
				<div className="mt-3 pt-2 border-top">
					<label htmlFor="within_ks" className="form-label"><strong>날짜 검색</strong></label>
					<div className="form-row mb-1">
						<select className="form-control" name="date_type"
						        value={param.date_type} onChange={this.facetChangeEvent}>
							<option value="input_date">입력(생성)일</option>
							<option value="modified_date">최종수정일</option>
						</select>
					</div>
					<div className="form-row">
						<div className="col pl-0">
							<input type="text" name="in_date_start" defaultValue={param.in_date_start}
							       onKeyUp={this.argsInputTextEvnet}
							       className="form-control" autoComplete="off"/>
						</div>
						<div className="col-1">
							<span className="text-center align-middle">~</span>
						</div>
						<div className="col pr-0">
							<input type="text" name="in_date_end" defaultValue={param.in_date_end} onKeyUp={this.argsInputTextEvnet}
							       className="form-control" autoComplete="off"/>
						</div>
					</div>
					<div className="form-row mt-1">
						<a href="#" className="btn btn-outline-primary btn-sm ml-auto" onClick={this.search}>범위 재설정</a>
					</div>
				</div>
				<div className="mt-3 pt-2 border-top">
					<label htmlFor="worker_id" className="form-label"><strong>작업자 검색</strong></label>
					<div className="input-group">
						<input type="text" name="worker_id" defaultValue={param.worker_id} onKeyUp={this.argsInputTextEvnet}
						       className="form-control" autoComplete="off"/>
						<button className="btn btn-sm btn-primary" type="button" id="search_worker">검색</button>
					</div>
					<div className="form-row mt-1">
						<a href="#" className="btn btn-outline-primary btn-sm ml-auto" onClick={this.search}>범위 재설정</a>
					</div>
				</div>

				{this.props.facet && getObjectLength(this.props.facet) > 0 ?
					Object.keys(this.props.facet).map((fa, i) => {
						const facet = this.props.facet[fa];
						// console.log(facet)
						if (!facet)
							return;
						return (
							<div key={fa}>
								<div className="form-side-search">
									<div className="form-tree-item active">
										<button type="button" className="btn-tree-nav">{AUTHORITY_FACET_NAME[fa]}</button>
										<div className="detail-tree-item">
											<div className="vertical-checkbox-list mt-3">
												<div className="checkbox-group">
													<div className="checkbox-group-cell mb-2">
														{facet.result.length > 0 && facet.result.map((item, index) => {
															let checked = false;
															if(this.props.param[fa]) {
																checked = this.props.param[fa].includes(item.title);
															}

															if(item.title==='')
																return ''

															const val = fa === 'registered_db_name' ? item.title.toUpperCase() : item.title
															item.title = fa === 'registered_db_name' ? item.title.toUpperCase() : item.title

															return (
																<React.Fragment key={index}>
																	<div className="checkbox-group-cell mb-0" key={index}>
																		<div className="custom-control custom-checkbox">
																			<input id={fa + '_' + index} name={fa} type="checkbox"
																			       className="custom-control-input"
																			       checked={checked} onChange={this.facetChangeEvent} value={val}/>
																			<label className="custom-control-label"
																			       htmlFor={fa + '_' + index}>{fa === 'term_status' ? STATUS_NAME[item.title] : item.title} ({getNumberFormat(item.count)})</label>
																		</div>
																	</div>
																</React.Fragment>
															)
														})}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)
					})
					: ''
				}
			</>
		)
	}
}

export default AuthorityFacet